import createActionTypes from './createActionTypes';

export const namespace = 'APPLICATION';

export const types = createActionTypes(namespace, [
  'INIT',
  'SET_PROPERTY',
  'SET_LANGUAGE',
  'SET_GCLID',
  'SET_CUSTOM_LABEL',
  'SET_ENABLE_DATA_LAYER_EVENTS',
  'SET_LOADING_GEOLOCATION',
  'SET_PINCHABLE_VIEWER',
  'TOGGLE_FULLSCREEN',
  'FETCH_IDLE_RESOURCES',
]);

export const initApplication = () => ({
  type: types.INIT,
});

export const setProperty = (propertyId) => ({
  type: types.SET_PROPERTY,
  payload: { propertyId },
});

export const setLanguage = (language) => ({
  type: types.SET_LANGUAGE,
  payload: { language },
});

export const setGclid = (gclid) => ({
  type: types.SET_GCLID,
  payload: { gclid },
});

export const setCustomLabel = (customLabel) => ({
  type: types.SET_CUSTOM_LABEL,
  payload: { customLabel },
});

export const setEnableDataLayerEvents = (enableDataLayerEvents) => ({
  type: types.SET_ENABLE_DATA_LAYER_EVENTS,
  payload: { enableDataLayerEvents },
});

export const setLoadingGeolocation = (loadingGeolocation) => ({
  type: types.SET_LOADING_GEOLOCATION,
  payload: { loadingGeolocation },
});

export const setPinchableViewer = (pinchableViewer) => ({
  type: types.SET_PINCHABLE_VIEWER,
  payload: { pinchableViewer },
});

export const toggleFullscreen = (active) => ({
  type: types.TOGGLE_FULLSCREEN,
  payload: { active },
});
